import { Container, Paper, Typography, Stack, Box } from "@mui/material";
import Swiper from "swiper";
import React, { useEffect } from "react";
import { isMobile, isTablet } from "react-device-detect";
import { useTranslation, Trans } from "react-i18next";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default function Team() {
  const { t, i18n } = useTranslation();

  function showMore(event) {
    var card = event.target.closest(".swiper-slide");

    if (card.classList.contains("show-more")) {
      card.classList.remove("show-more");
    } else {
      card.classList.add("show-more");
    }
  }
  useEffect(() => {
    // Update the document title using the browser API
    var dir = "horizontal";
    if (isMobile || isTablet) {
      dir = "vertical";
    } else {
      dir = "horizontal";
    }
    var mySwiper = new Swiper(".swiper-container", {
      // Optional parameters
      direction: dir,
      loop: false,
      centeredSlides: false,
      speed: 800,
      slidesPerView: 3,
      spaceBetween: 40,
      threshold: 5,

      // If we need pagination
      //pagination: {
      //el: ".swiper-pagination",
      //clickable: true,
      //},

      // Navigation arrows
      //navigation: {
      //nextEl: ".swiper-button-next",
      //prevEl: ".swiper-button-prev",
      //},
      //breakpoints: {
      //1120: {
      //          slidesPerView: 2,
      //spaceBetween: 40,
      //centeredSlides: false,
      //},
      //799: {
      //          slidesPerView: 1,
      //spaceBetween: 20,
      //centeredSlides: true,
      //loop: true,
      //},
      //},
    });

    /* Social Hover */
    var icon = document.querySelectorAll(".icon");

    icon.forEach(function (el) {
      el.addEventListener("mouseenter", followCursor);
    });

    function followCursor(event) {
      var pointer = event.currentTarget
          .closest(".swiper-slide")
          .querySelector(".pointer"),
        index = event.currentTarget.dataset.index,
        sizeIcon = 60 * index + 25;

      pointer.style.transform = `translateX(${sizeIcon}px)`;
    }

    /* end */
  }, []);
  return (
    <Container
      className="team-page"
      component={Paper}
      sx={{
        alignItems: "center",
        p: 4,
        my: 10,
        flex: 1,
        marginTop: "unset",
        marginBottom: "unset",
      }}
      style={{margin:"auto"}}
    >
      <div>
        <div className="wrapper">
          <section className="module-team">
            <div className="team">
              <Typography
                variant="h6"
                color="primary"
                style={{ textAlign: "center", margin: "0" }}
              >
                <Trans t={t}>Meet our team</Trans>
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                style={{ padding: "1em", color: "lightgrey" }}
              >
                <Trans t={t}>
                  Comprised of experts in web3 technology, we're dedicated to
                  disrupting the traditional gambling industry and bringing a
                  new level of transparency and fairness to the world of online
                  betting.
                </Trans>
              </Typography>
              <Typography style={{ padding: "1em" }}>
                <Trans t={t}>
                  Join our team of innovators in the crypto gambling industry!
                  We are always looking for free thinkers to join us. DM us on
                  our socials.
                </Trans>
              </Typography>
              <div className="team-cards">
                {/* Slider main container */}
                <div className="swiper-container">
                  {/* Additional required wrapper */}
                  <div className="swiper-wrapper">
                    <div className="swiper-slide">
                      <div className="card">
                        <span className="bg"></span>
                        <span onClick={showMore} className="more"></span>
                        <figure className="photo">
                          <img src="/img/team/anchih.jpg" />
                        </figure>
                        <article className="text">
                          <p className="name">
                            <Trans t={t}>Anchih Hsiao</Trans>
                          </p>
                          <p className="role">
                            <Trans t={t}>Project Owner</Trans>
                          </p>
                          <p className="status">
                            <span className="doxxed">
                              <Trans t={t}>Doxxed</Trans> &nbsp;
                            </span>
                            <svg
                              className="checkmark"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 52 52"
                            >
                              <circle
                                className="checkmark__circle"
                                cx="26"
                                cy="26"
                                r="25"
                                fill="none"
                              />
                              <path
                                className="checkmark__check"
                                fill="none"
                                d="M14.1 27.2l7.1 7.2 16.7-16.8"
                              />
                            </svg>
                          </p>
                          <p className="desc">
                            <Trans t={t}>
                              Based in Taiwan, Anchih started investing in
                              crypto in 2017. He has experience in the crypto
                              mining industry and the gaming industry among
                              other things
                            </Trans>
                          </p>
                        </article>

                        <div className="social">
                          <span className="pointer"></span>
                          <div className="icons">
                            <a
                              className="icon"
                              href="https://www.linkedin.com/in/anchih-hsiao-1b2223255/"
                              rel="noreferrer"
                              target="_blank"
                              data-index="0"
                            >
                              <img
                                alt="LinkedIn Icon"
                                src="/img/logos/linkedin.svg"
                              />
                            </a>
                            <a
                              className="icon"
                              href="https://opensea.io/N2wElite"
                              rel="noreferrer"
                              target="_blank"
                              data-index="1"
                            >
                              <img
                                alt="OpenSea Icon"
                                src="/img/logos/opensea.svg"
                              />
                            </a>
                            <a
                              className="icon"
                              href="https://etherscan.io/address/0x24Bd155D4994B99623A2fA5B8cB8Bd704E51239F"
                              rel="noreferrer"
                              target="_blank"
                              data-index="2"
                            >
                              <img
                                alt="Etherscan Icon"
                                src="/img/logos/etherscan.svg"
                              />
                            </a>
                            <a
                              className="icon"
                              href="mailto:fornflpsn0006@gmail.com"
                              rel="noreferrer"
                              target="_blank"
                              data-index="3"
                            >
                              <img
                                alt="Email Icon"
                                src="/img/logos/email.svg"
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="card">
                        <span className="bg"></span>
                        <span onClick={showMore} className="more"></span>
                        <figure className="photo">
                          <img src="/img/team/pstar.png" />
                        </figure>
                        <article className="text">
                          <p className="name">pstar</p>
                          <p className="role">
                            <Trans t={t}>Project Manager</Trans>
                          </p>
                          <p className="desc">
                            <Trans t={t}>
                              pstar has experience leading multiple gaming
                              focused services and communities. His expertise in
                              web3 and computer science background are an asset
                              for nice2win
                            </Trans>
                          </p>
                        </article>

                        <div className="social">
                          <span className="pointer"></span>
                          <div className="icons">
                            <a
                              className="icon"
                              href="https://twitter.com/ApingSince2016"
                              rel="noreferrer"
                              target="_blank"
                              data-index="0"
                            >
                              <img
                                alt="Twitter Icon"
                                src="/img/logos/twitter.svg"
                              />
                            </a>
                            <a
                              className="icon"
                              href="https://opensea.io/pstar"
                              rel="noreferrer"
                              target="_blank"
                              data-index="1"
                            >
                              <img
                                alt="OpenSea Icon"
                                src="/img/logos/opensea.svg"
                              />
                            </a>
                            <a
                              className="icon"
                              href="https://etherscan.io/address/0x16febDD1ca6EfC5914b342612bd817d93aFf23dE"
                              rel="noreferrer"
                              target="_blank"
                              data-index="2"
                            >
                              <img
                                alt="Etherscan Icon"
                                src="/img/logos/etherscan.svg"
                              />
                            </a>
                            <a
                              className="icon"
                              href="mailto:web3pstar@protonmail.com"
                              rel="noreferrer"
                              target="_blank"
                              data-index="3"
                            >
                              <img
                                alt="Email Icon"
                                src="/img/logos/email.svg"
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="card">
                        <span className="bg"></span>
                        <span onClick={showMore} className="more"></span>
                        <figure className="photo">
                          <img src="/img/team/jeez.png" />
                        </figure>
                        <article className="text">
                          <p className="name">web3jeez</p>
                          <p className="role">
                            <Trans t={t}>Lead Developer</Trans>
                          </p>
                          <p className="desc">
                            <Trans t={t}>
                              web3jeez is a full-stack developer with high-end
                              skills in smart contract development. He has
                              experience building online platforms including
                              web3 dapps
                            </Trans>
                          </p>
                        </article>

                        <div className="social">
                          <span className="pointer"></span>
                          <div className="icons">
                            <a
                              className="icon"
                              href="https://twitter.com/web3jeez"
                              rel="noreferrer"
                              target="_blank"
                              data-index="0"
                            >
                              <img
                                alt="Twitter Icon"
                                src="/img/logos/twitter.svg"
                              />
                            </a>
                            <a
                              className="icon"
                              href="https://opensea.io/web3jeez"
                              rel="noreferrer"
                              target="_blank"
                              data-index="1"
                            >
                              <img
                                alt="OpenSea Icon"
                                src="/img/logos/opensea.svg"
                              />
                            </a>
                            <a
                              className="icon"
                              href="https://etherscan.io/address/0xECA451FAdb19968D9A1A63d053f43329Ac7C9a5A"
                              rel="noreferrer"
                              target="_blank"
                              data-index="2"
                            >
                              <img
                                alt="Etherscan Icon"
                                src="/img/logos/etherscan.svg"
                              />
                            </a>
                            <a
                              className="icon"
                              href="mailto:web3jeez@protonmail.com"
                              rel="noreferrer"
                              target="_blank"
                              data-index="3"
                            >
                              <img
                                alt="Email Icon"
                                src="/img/logos/email.svg"
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="swiper-pagination" />
              </div>
            </div>
          </section>
        </div>
      </div>
    </Container>
  );
}
